module.exports = __webpack_public_path__ + "img/logo-previne-brasil.6686ca08.png";